import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import s from './AccountButton.module.scss'; // отдельный scss-модуль
import { getIsLoggedIn } from 'store/auth/auth-selectors';
import { ROUTES } from 'configs/routeConstants';
import useMetrics from '@hooks/useMetrics';
import { METRIC_EVENTS, METRIC_EVENTS_TRIGGERS } from '@configs/metrics/events';
import img from '@assets/img/profile-avatar.jpg'
import { useCompanyTheme } from '@hooks/useCompanyTheme';
import { getCurrentThemeFromDom, getThemeAsset, normalizeTheme } from '@configs/themeAssets';
interface Props {
  /** текст ссылки, плейсхолдеры из JSON передаём отсюда */
  labelSigned: string;
  labelUnsigned: string;
}

const AccountButton: React.FC<Props> = ({ labelSigned, labelUnsigned }) => {
  const isLoggedIn = useSelector(getIsLoggedIn);
  // const _user = useSelector(getUserInfo);

  const { trackEvent } = useMetrics();
  const handleProfileClick = () =>
    trackEvent(METRIC_EVENTS.profile_main, METRIC_EVENTS_TRIGGERS.main);
  const handleSignInClick = () => trackEvent(METRIC_EVENTS.auth_enter, METRIC_EVENTS_TRIGGERS.main);


  const company = useCompanyTheme()

  const theme =
    getCurrentThemeFromDom() ??
    normalizeTheme(company) ??
    null;

  const avatar = getThemeAsset(theme, 'avatarButton', img)
  if (!avatar) return null;

  return isLoggedIn ? (
    <Link to={ROUTES.profile.root} className={s.account} onClick={handleProfileClick}>
      <img src={avatar} alt="avatar" className={s.avatar} />
      <span className={s.link}>{labelSigned}</span>
    </Link>
  ) : (
    <Link to={ROUTES.signin} className={s.buttonPrimary} onClick={handleSignInClick}>
      <span className={s.link}>{labelUnsigned}</span>
    </Link>
  );
};

export default AccountButton;
